module.exports = __webpack_public_path__ + "static/media/newDriveStep1.363e0fb4.svg";